module.exports = __webpack_public_path__ + "img/booking_icon.c67d0df7.svg";